import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faDownload, faFileContract, faShieldHalved } from "@fortawesome/free-solid-svg-icons";
import { adminFluxopayApi } from "../../services/fluxopayApi";
import "../pages/AdminFluxopayPage.css";

const text = {
  unavailable: "N\u00e3o informado",
  heading: "COMPROVA\u00c7\u00c3O DA TRANSA\u00c7\u00c3O",
  clinic: "Cl\u00ednica",
  transactionId: "ID transa\u00e7\u00e3o Asaas",
  code: "C\u00f3digo",
  linked: "A cobran\u00e7a est\u00e1 vinculada a um documento dispon\u00edvel para comprova\u00e7\u00e3o.",
  unavailablePdf: "Esta transa\u00e7\u00e3o n\u00e3o possui PDF assinado dispon\u00edvel no armazenamento.",
  missingContract: "Contrato assinado n\u00e3o localizado",
  authorization: "Documento associado \u00e0 autoriza\u00e7\u00e3o do pagamento",
  disclaimer: "O contrato \u00e9 uma evid\u00eancia da autoriza\u00e7\u00e3o, mas deve ser acompanhado dos registros do atendimento em eventual contesta\u00e7\u00e3o.",
  noContract: "Nenhum contrato assinado foi relacionado a esta cobran\u00e7a.",
};
const brl = cents => (Number(cents || 0) / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const dateTime = value => value ? new Date(value).toLocaleString("pt-BR") : text.unavailable;

export default function TransactionProofModal({ data, onClose, contractRequest = adminFluxopayApi.transactionContract }) {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState("");
  const transaction = data.transaction || {};
  const order = transaction.order || {};
  const proof = data.proof || {};
  const contract = proof.contract;

  const contractBlob = async () => {
    const response = await contractRequest(transaction.id);
    return URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
  };
  const downloadContract = async () => {
    setDownloading(true); setError("");
    try {
      const url = await contractBlob();
      const anchor = document.createElement("a");
      anchor.href = url; anchor.download = `Contrato_${contract.code}.pdf`;
      document.body.appendChild(anchor); anchor.click(); anchor.remove();
      setTimeout(() => URL.revokeObjectURL(url), 30000);
    } catch (requestError) {
      setError(requestError?.response?.data?.message || "N\u00e3o foi poss\u00edvel baixar o contrato.");
    } finally { setDownloading(false); }
  };
  const viewContract = async () => {
    const viewer = window.open("", "_blank", "noopener,noreferrer");
    setDownloading(true); setError("");
    try {
      const url = await contractBlob();
      if (viewer) viewer.location = url; else window.open(url, "_blank", "noopener,noreferrer");
      setTimeout(() => URL.revokeObjectURL(url), 120000);
    } catch (requestError) {
      if (viewer) viewer.close();
      setError(requestError?.response?.data?.message || "N\u00e3o foi poss\u00edvel visualizar o contrato.");
    } finally { setDownloading(false); }
  };

  return <div className="afxp-modal-backdrop" onMouseDown={onClose}>
    <section className="afxp-modal afxp-proof-modal" onMouseDown={event => event.stopPropagation()}>
      <header>
        <div><small>{text.heading}</small><h2>{proof.external_reference || order.external_id}</h2></div>
        <button type="button" onClick={onClose} aria-label="Fechar">{"\u00d7"}</button>
      </header>
      <div className={`afxp-proof-status ${contract?.available ? "is-valid" : "is-warning"}`}>
        <FontAwesomeIcon icon={contract?.available ? faShieldHalved : faFileContract} />
        <div><b>{contract?.available ? "Contrato assinado localizado" : text.missingContract}</b><span>{contract?.available ? text.linked : text.unavailablePdf}</span></div>
      </div>
      {error && <p className="afxp-proof-error">{error}</p>}
      <div className="afxp-review-grid">
        <Field label={text.clinic} value={transaction.entidade?.nome} />
        <Field label="Paciente" value={proof.paciente?.nome} />
        <Field label="CPF" value={proof.paciente?.cpf} />
        <Field label="Agendamento" value={proof.agendamento_id ? `#${proof.agendamento_id}` : null} />
        <Field label="Canal" value={proof.payment_channel === "payment_link" ? "Link de pagamento" : proof.payment_channel} />
        <Field label="Valor" value={brl(order.gross_amount_cents || transaction.amount_cents)} />
        <Field label="ID Fluxopay" value={proof.external_reference} mono />
        <Field label="ID Checkout Asaas" value={proof.provider_charge_id} mono />
        <Field label={text.transactionId} value={proof.provider_transaction_id} mono />
        <Field label="Status" value={order.status || transaction.status} />
      </div>
      <section className="afxp-proof-contract">
        <div className="afxp-proof-title"><FontAwesomeIcon icon={faFileContract} /><div><b>Contrato do atendimento</b><span>{text.authorization}</span></div></div>
        {contract ? <>
          <div className="afxp-proof-contract-grid"><Field label={text.code} value={contract.code} mono /><Field label="Assinado em" value={dateTime(contract.signed_at)} /><Field label="Status" value={contract.status} /></div>
          {contract.sha256 && <div className="afxp-proof-hash"><span>SHA-256 do PDF</span><code>{contract.sha256}</code></div>}
          {contract.available && <div className="afxp-proof-actions"><button className="afxp-secondary" type="button" onClick={viewContract} disabled={downloading}>Visualizar contrato</button><button className="afxp-primary" type="button" onClick={downloadContract} disabled={downloading}><FontAwesomeIcon icon={faDownload} /> {downloading ? "Carregando..." : "Baixar PDF"}</button></div>}
        </> : <p className="afxp-proof-empty">{text.noContract}</p>}
      </section>
      <section className="afxp-proof-timeline">
        <div className="afxp-proof-title"><FontAwesomeIcon icon={faCheckCircle} /><div><b>Linha do tempo</b><span>Eventos registrados pelo Fluxopay</span></div></div>
        {(proof.timeline || []).map((event, index) => <div className="afxp-proof-event" key={`${event.type}-${index}`}><i /><div><b>{event.label}</b><span>{dateTime(event.at)}</span></div></div>)}
      </section>
      <footer><span className="afxp-proof-note">{text.disclaimer}</span><button className="afxp-secondary" type="button" onClick={onClose}>Fechar</button></footer>
    </section>
  </div>;
}

function Field({ label, value, mono }) {
  return <span>{label}<b className={mono ? "afxp-mono" : ""}>{value || text.unavailable}</b></span>;
}
